"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GDGuidesSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _default = _interopRequireDefault(require("./default.js"));
var _split = _interopRequireDefault(require("./split.js"));
/**
 * Render GD Guides Section
 * @module GDGuidesSection
 *
 * @param {Object} props React props for GD Guides Section
 * @param {string} props.layout GD Guides Section layout
 * @returns {React.ReactElement} GD Guides Section
 * @public
 */
function GDGuidesSection({
  layout = 'default',
  ...guidesProps
}) {
  return {
    'default': /*#__PURE__*/_react.default.createElement(_default.default, guidesProps),
    'split': /*#__PURE__*/_react.default.createElement(_split.default, (0, _extends2.default)({
      layout: layout
    }, guidesProps)),
    'split-reverse': /*#__PURE__*/_react.default.createElement(_split.default, (0, _extends2.default)({
      layout: layout
    }, guidesProps))
  }[layout];
}
GDGuidesSection.propTypes = {
  layout: _propTypes.default.oneOf(['default', 'split', 'split-reverse']).isRequired
};